import { useState } from "react";
import { accountService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState, useDebounce } from "@miplatform/hooks";
import { createUUID } from "@miplatform/utils";
import { ACCOUNTS_TAB_TO_TYPE } from "./accountsConstants";

const getAccountsUUID = createUUID();

export const useAccountsViewModel = ({ tab }) => {
  const [accounts, setAccounts] = useState([]);
  const [recentAccounts, setRecentAccounts] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [search, setSearch] = useState("");

  const debouncedSearch = useDebounce(search, 300);
  const stateManager = useComponentState();

  const handleRefresh = () => setRefresh((prev) => !prev);

  const getAccounts = ({ top, skip }) => {
    return stateManager.run(async () => {
      return accountService.accounts.getAll({
        sort: "name",
        filters: {
          accountType: ACCOUNTS_TAB_TO_TYPE[tab],
          name: { contains: debouncedSearch },
        },
        top,
        skip,
      });
    }, getAccountsUUID);
  };

  const getRecentAccounts = ({ sort, filters, top }) => {
    return stateManager.run(async () => {
      return accountService.accounts.getAll({
        sort,
        filters: { ...filters, accountType: ACCOUNTS_TAB_TO_TYPE[tab] },
        top,
      });
    });
  };

  const handleDeleteAccount = (data) => {
    stateManager.run(async () => {
      const response = await accountService.accounts.deleteAccount({
        id: data.id,
        modifiedOn: data.modifiedOn,
        toastMessageConfig: {
          success: {
            text: `${data.name} was deleted.`,
          },
          failure: {
            text: `Failed to delete ${data.name}.`,
          },
        },
      });
      if (response.status === HTTP_STATUSES.OK) {
        handleRefresh();
      }
    });
  };

  return {
    isLoading: stateManager.isBusy(),
    debouncedSearch,
    refresh,
    accounts,
    search,
    setSearch,
    handleRefresh,
    setAccounts,
    getAccounts,
    handleDeleteAccount,
    getRecentAccounts,
    setRecentAccounts,
    recentAccounts,
  };
};
